const space = ' ';
export default class StoreDeliveryPossibleArea {
    _flattenList;
    constructor(siDo, siGunGu, eupMyeonDongList) {
        this._flattenList = eupMyeonDongList.flatMap((item) => {
            const flattenRi = item.riConstantGroups.map((ri) => ({
                siDo,
                siGunGu,
                eupMyeonDong: item.name.concat(`${space}${ri.name}`),
                constantGroupId: ri.constantGroupId,
                parentId: item.constantGroupId,
            }));
            return [
                {
                    siDo,
                    siGunGu,
                    eupMyeonDong: item.name,
                    constantGroupId: item.constantGroupId,
                },
                ...flattenRi,
            ];
        });
    }
    get list() {
        return this._flattenList;
    }
}
